export default __webpack_public_path__ + "static/media/2335.0257fc01.png";